/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SaveScholarshipTypeEnrollmentLinksRequestViewModel } from "../types/SaveScholarshipTypeEnrollmentLinksRequestViewModel.ts";

export const saveScholarshipTypeEnrollmentLinksRequestViewModelSchema =
  z.object({
    classStudentIds: z
      .array(z.number().int())
      .describe(
        "IDs das turmas a vincular à bolsa. A lista substitui integralmente o vínculo anterior; lista vazia remove todos.",
      )
      .nullish(),
  }) as unknown as ToZod<SaveScholarshipTypeEnrollmentLinksRequestViewModel>;
